import { combineReducers } from "redux";
import {
  authorization,
  profile,
  currentRoute,
  notifications,
  app,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
  customers,
  customersForm,
  offers,
  offersForm,
  visits,
  visitsForm,
} from "./Reducers";

export default combineReducers({
  visits,
  visitsForm,
  offers,
  offersForm,
  customers,
  customersForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  alerts,
  alertsForm,
  currentTheme,
});
